<!-- src/views/VoiceMail.vue -->
<template>
  <div class="voicemail-container">
    <div class="header-container">
      <h2>{{ getSelectedCompany?.name + ' / ' + getSelectedUser?.name }}</h2>
    </div>

    <div class="records-box">
      <voice-mail-record
        v-for="record in voicemailRecords"
        :key="record.callSid"
        :record="record"
        @update:record="handleRecordUpdate"
      />
    </div>

    <ok-dialog
      v-if="showOkDialog"
      :title="OkDialogTitle"
      :message="OkDialogMessage"
      @close="showOkDialog = false"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';
import VoiceMailRecord from '../components/VoiceMailRecord.vue';
import OkDialog from '../components/OkDialog.vue';
import { eventService } from '../services/EventService';

export default {
  name: 'VoiceMail',
  
  components: {
    VoiceMailRecord,
    OkDialog
  },

  data() {
    return {
      voicemailRecords: [],
      showOkDialog: false,
      OkDialogTitle: '',
      OkDialogMessage: '',
    };
  },

  computed: {
    ...mapState(['user']),
    ...mapGetters(['userRole', 'getSelectedUser', 'getSelectedCompany']),
  },

  methods: {

    updateOrInsertRecord(newRecord) {
      this.handleRecordUpdate(newRecord);
//      const index = this.intakeRecords.findIndex(record => record.callSid === newRecord.callSid);
//     if (index !== -1) {
//        this.intakeRecords[index] = newRecord;
//      } else {
//        this.intakeRecords.unshift(newRecord);
//      }
//      this.removeCompletedItems();
    },

    handleVoicemailsEvent(event) {
      console.log('voicemailsEvent');
      const data = JSON.parse(event.data);
      delete data._id;
      this.updateOrInsertRecord(data);
    },

    listenForVoicemailsUpdates() {
      const events = eventService.getConnection(this.getSelectedCompany.companyNumber);
      if (events) {
        events.addEventListener('voicemails', (event) => this.handleVoicemailsEvent(event));
      }
    },

    unListenForVoicemailsUpdates() {
      const selectedCompany = this.getSelectedCompany;
      if (selectedCompany?.companyNumber) {
        const events = eventService.getConnection(this.getSelectedCompany.companyNumber);
        if (events) {
          events.removeEventListener('voicemails', (event) => this.handleVoicemailsEvent(event));
        }
      }
    },

    handleRecordUpdate(updatedRecord) {
      if (updatedRecord.status === 'archived') {
        // Remove the archived record from the array
        const recordIndex = this.voicemailRecords.findIndex(
          record => record.callSid === updatedRecord.callSid
        );
        if (recordIndex !== -1) {
          this.voicemailRecords.splice(recordIndex, 1);
        }
      } else {
        // Update existing record (for non-archived status updates like flagging)
        const recordIndex = this.voicemailRecords.findIndex(
          record => record.callSid === updatedRecord.callSid
        );
        if (recordIndex !== -1) {
          this.voicemailRecords.splice(recordIndex, 1, updatedRecord);
        } else {
          this.voicemailRecords.unshift(updatedRecord);
        }
      }
    },

    async fetchVoicemailRecords() {
      try {
        const companyNumber = this.getSelectedCompany.companyNumber;
        const response = await axios.get(`/portaldb/db/voicemail/${companyNumber}`);
        this.voicemailRecords = response.data;
      } catch (error) {
        console.error('Error fetching voicemail records:', error);
        this.OkDialogTitle = 'Error';
        this.OkDialogMessage = 'An error occurred while fetching voicemail records.';
        this.showOkDialog = true;
      }
    }

  },

  mounted() {
    this.fetchVoicemailRecords();
    this.listenForVoicemailsUpdates();
  },

  beforeUnmount() {
    this.unListenForVoicemailsUpdates();
  }

};
</script>

<style scoped>
.voicemail-container {
  padding: 20px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.records-box {
  border: 4px solid #d2b48c;
  padding: 20px;
}
</style>
